import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from "@angular/router";
import { Location } from "@angular/common";
import { MainserviceService } from './../mainservice.service';
import 'rxjs/add/operator/switchMap';

@Component({
  selector: 'app-mall-shop-detail',
  templateUrl: './mall-shop-detail.component.html',
  styleUrls: ['./mall-shop-detail.component.scss']
})
export class MallShopDetailComponent implements OnInit {
  shop:any;
  shopstat:any;
  promos:any  
  promoFilter:any = { code: ''}
  
   //initializing p to one
   p: number = 1; 

  constructor(
    private mainservice: MainserviceService,
    private route:ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit() {
    this.route.paramMap.switchMap((params :ParamMap) =>
    this.mainservice.getShop(+params.get('id')))
  .subscribe( shop => { this.shop = shop
  
    this.mainservice.getShopPromoStats(shop.id).subscribe(data =>
    this.shopstat =data[0])  

    this.mainservice.getShopPromocodes(shop.id).subscribe(data =>{
      this.promos =data})

  }
)
  
  }
  goBack():void {
    this.location.back();
  }
}



// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/mall-shop-detail/mall-shop-detail.component.ts